export default "__VITE_ASSET__D9E7PzvJ__"